module.exports = __webpack_public_path__ + "img/pic_button_suspend_active@2x.8fc2c282.png";